import {
  Button,
  Col,
  Container,
  HomeIcon,
  Row,
} from 'plataforma-fundacao-componentes';
import { languageValues } from 'utils/LanguageUtils';

export default function AgradecimentoNaoAssociado() {
  return (
    <Container verticalPadding>
      <Row>
        <Col className='title text-center' centralized>
          {languageValues.pages.naoAssociado.agradecimento.title}
        </Col>
      </Row>
      <Row>
        <Col className='sub-title text-center' centralized>
          {languageValues.pages.naoAssociado.agradecimento.subtitle}
        </Col>
        <Col buttonActionsCol centralized>
          <Button
            leftIcon={<HomeIcon />}
            onClick={() => {
              window.location.replace(
                'https://www.sicredi.com.br/site/fundacao/'
              );
            }}
          >
            {languageValues.buttons.initialPage}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
